import { render, staticRenderFns } from "./foto.vue?vue&type=template&id=e9fa6ed2"
import script from "./foto.vue?vue&type=script&lang=js"
export * from "./foto.vue?vue&type=script&lang=js"
import style0 from "./foto.vue?vue&type=style&index=0&id=e9fa6ed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports